export default {
  period: {
    hours24: 'In 24 hours',
    day: 'Today',
    yesterday: 'Yesterday',
    week: 'Week',
    month: 'Month',
    anytime: 'All time',
    range: 'Period',
  },
};
